import {
   Component, OnInit, Input, ElementRef, ViewChild
} from '@angular/core';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {ChangePassSignComponent} from './change-pass-sign/change-pass-sign.component';
import {IdexService} from 'app/idex.service';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from 'app/shared/toast/toast';
import {fromEvent as observableFromEvent} from 'rxjs';
import {pairwise, takeUntil, switchMap, withLatestFrom} from 'rxjs/operators';
import { DatePipe } from '@angular/common';

declare let $: any;

@Component({
   selector: 'app-register-signature',
   templateUrl: './register-signature.component.html',
   styleUrls: ['./register-signature.component.css', '../../../assets/font_stylesheet.css']
})

export class RegisterSignatureComponent implements OnInit {
   error: string;
   groupPattern: string;
   groupPatternInit: string;
   imageSignatureOriginal: any;
   imageSignatureTemp: any;
   imageInitOriginal: any;
   imageInitTemp: any;
   imageSignaturePreview: any;
   imageInitializeTemp: any;
   imageInitializePreview: any;
   fullNameValue: any;
   initializeName: any;
   public signatureId: any;
   public initialId: any;
   blobBin: any;
   blobInit: any;
   i: any;
   array: any;
   array2: any;
   fileBlob: any;
   fileInit: any;
   signatureChange = false;
   initChange = false;
   includeName: any;
   includeDate: any;
   signatureChangeType = 'original';
   initialChangeType = 'original';
   signatureChangeObj: any;
   initChangeObj: any;
   hasSignature: any;
   hasInitial: any;
   registerSignature: any;
   registerInitialize: any;
   imageURL: string;
   imageInitURL: string;
   currentDate: Date;
   initializeSign = '';
   public selectPatternStyle = 'Singnature';
   noImage = false;

   constructor(public service: IdexService,
               private dialog: MatDialog,
               private translate: TranslateService,
               private dialogRef: MatDialogRef<RegisterSignatureComponent>,
               public toast: Toast) {
   }

   colors = [
      {value: 'black', viewValue: 'Black'},
      {value: 'blue', viewValue: 'Blue'}
   ];

   sizes = [
      {value: 'small', viewValue: 'Small'},
      {value: 'normal', viewValue: 'Normal'},
      {value: 'large', viewValue: 'Large'}
   ];

   tabSelected = 0;
   colorSelected = 'black';
   sizeSelected = 'normal';
   radius = 5;
   errorMessage = '';
   passSignValue = 'pass';
   isFirst = true;

   @ViewChild('fullname') fullname: ElementRef;
   @ViewChild('initialize') inputNameinit: ElementRef;
   @ViewChild('canvas', { static: true }) public canvas: ElementRef;
   @ViewChild('canvasPattern1', { static: true }) public canvasPattern1: ElementRef;
   @ViewChild('canvasPattern2', { static: true }) public canvasPattern2: ElementRef;
   @ViewChild('canvasPattern3', { static: true }) public canvasPattern3: ElementRef;
   @ViewChild('canvasPattern4', { static: true }) public canvasPattern4: ElementRef;
   @ViewChild('canvasPattern5', { static: true }) public canvasPattern5: ElementRef;
   @ViewChild('canvasPattern6', { static: true }) public canvasPattern6: ElementRef;
   @ViewChild('canvasPattern7', { static: true }) public canvasPattern7: ElementRef;
   @ViewChild('canvasPattern8', { static: true }) public canvasPattern8: ElementRef;
   @ViewChild('canvasPattern9', { static: true }) public canvasPattern9: ElementRef;
   @ViewChild('canvasPattern10', { static: true }) public canvasPattern10: ElementRef;
   @ViewChild('canvasPattern11', { static: true }) public canvasPattern11: ElementRef;
   @ViewChild('canvasPattern12', { static: true }) public canvasPattern12: ElementRef;
   @ViewChild('canvasPattern13', { static: true }) public canvasPattern13: ElementRef;
   @ViewChild('canvasPattern14', { static: true }) public canvasPattern14: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;
   @ViewChild('canvasInitialize1', { static: true }) public canvasInitialize1: ElementRef;
   @ViewChild('canvasInitialize2', { static: true }) public canvasInitialize2: ElementRef;
   @ViewChild('canvasInitialize3', { static: true }) public canvasInitialize3: ElementRef;
   @ViewChild('canvasInitialize4', { static: true }) public canvasInitialize4: ElementRef;
   @ViewChild('canvasInitialize5', { static: true }) public canvasInitialize5: ElementRef;
   @ViewChild('canvasInitialize6', { static: true }) public canvasInitialize6: ElementRef;
   @ViewChild('canvasInitialize7', { static: true }) public canvasInitialize7: ElementRef;
   @ViewChild('canvasInitialize8', { static: true }) public canvasInitialize8: ElementRef;
   @ViewChild('canvasInitialize9', { static: true }) public canvasInitialize9: ElementRef;
   @ViewChild('canvasInitialize10', { static: true }) public canvasInitialize10: ElementRef;
   @ViewChild('canvasInitialize11', { static: true }) public canvasInitialize11: ElementRef;
   @ViewChild('canvasInitialize12', { static: true }) public canvasInitialize12: ElementRef;
   @ViewChild('canvasInitialize13', { static: true }) public canvasInitialize13: ElementRef;
   @ViewChild('canvasInitialize14', { static: true }) public canvasInitialize14: ElementRef;
   @ViewChild('canvasInitializeTmp', { static: true }) public canvasInitializeTmp: ElementRef;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('btnOK', { static: true }) public buttonOK: MatButton;

   private changePassSignature: MatDialogRef<ChangePassSignComponent>;

   // setting a width and height for the canvas
   @Input() public width = 475;
   @Input() public height = 190;

   private cx: CanvasRenderingContext2D;

   public ngOnInit() {
      if(this.registerSignature || this.registerInitialize){
         this.noImage = true;
      }
      if (this.registerInitialize || this.selectPatternStyle === 'Singnature') {
         setTimeout(() => {
            this.fullname.nativeElement.focus();
            this.selectSignatureButton('Singnature');
         }, 100);
      } else if (this.registerSignature || this.selectPatternStyle === 'InitializeSign') {
         setTimeout(() => {
            this.inputNameinit.nativeElement.focus();
            this.selectSignatureButton('InitializeSign');
         }, 100);
      }
      // set initial input
      const splitName =
         typeof this.fullNameValue === 'string'
            ? this.fullNameValue.trim().split(/\s+/, 3)
            : this.service.user.name.trim().split(/\s+/, 3);

      this.fullNameValue = splitName.join(' ');
      this.initializeName = splitName[0].charAt(0);
      if (splitName.length > 1) {
         this.initializeName += splitName[1].charAt(0);
      }
      this.initializeSign = this.initializeName;
      this.buttonOK.disabled = true;
      this.imageSignaturePreview = this.imageSignatureOriginal;
      this.imageInitializePreview = this.imageInitOriginal;
      // get the context
      const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
      this.cx = canvasEl.getContext('2d');

      // set the width and height
      canvasEl.width = this.width;
      canvasEl.height = this.height;

      // set some default properties about the line
      // this.cx.lineWidth = 3;
      this.cx.lineCap = 'round';
      this.cx.strokeStyle = '#000';

      this.currentDate = new Date();
      // we'll implement this method to start capturing mouse events
      this.generateSignature(this.fullNameValue);
      this.captureEvents(canvasEl);
      this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=false', (dataUrl) => {
         const arr = dataUrl.split(';',1);
         if (arr.length > 0 && arr[0] === 'data:image/png') {
            document.getElementById('signatureTmp').setAttribute('src', dataUrl);
         }
      });
      this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true', function(dataUrl) {
         const arr = dataUrl.split(';',1);
         if (arr.length > 0 && arr[0] === 'data:image/png') {
            document.getElementById('initializeTmp').setAttribute('src', dataUrl);
         }
      });
   }

   generateSignature(fullNameVal) {
      fullNameVal = typeof fullNameVal === 'string' ? fullNameVal : this.service.user.name.trim();
      if (fullNameVal !== undefined) {
         const value = fullNameVal.trim();
         if (/[<|>\\\/:?*"]/g.test(value)) {
            this.translate.get('alert.create_folder_error').subscribe(s => {
               this.error = s;
            });
            this.buttonOK.disabled = true;
         } else {
            this.translate.get('alert.empty').subscribe(s => {
               this.error = s;
            });

            this.groupPattern = null;
            // get the context
            const canvasEl1: HTMLCanvasElement = this.canvasPattern1.nativeElement;
            const canvasEl2: HTMLCanvasElement = this.canvasPattern2.nativeElement;
            const canvasEl3: HTMLCanvasElement = this.canvasPattern3.nativeElement;
            const canvasEl4: HTMLCanvasElement = this.canvasPattern4.nativeElement;
            const canvasEl5: HTMLCanvasElement = this.canvasPattern5.nativeElement;
            const canvasEl6: HTMLCanvasElement = this.canvasPattern6.nativeElement;
            const canvasEl7: HTMLCanvasElement = this.canvasPattern7.nativeElement;
            const canvasEl8: HTMLCanvasElement = this.canvasPattern8.nativeElement;
            const canvasEl9: HTMLCanvasElement = this.canvasPattern9.nativeElement;
            const canvasEl10: HTMLCanvasElement = this.canvasPattern10.nativeElement;
            const canvasEl11: HTMLCanvasElement = this.canvasPattern11.nativeElement;
            const canvasEl12: HTMLCanvasElement = this.canvasPattern12.nativeElement;
            const canvasEl13: HTMLCanvasElement = this.canvasPattern13.nativeElement;
            const canvasEl14: HTMLCanvasElement = this.canvasPattern14.nativeElement;

            const fonts = ['calligraffittiregular', 'damionregular', 'dancing_scriptbold', 'great_vibesregular', 'pacificoregular',
               'pinyon_scriptregular', 'rock_saltregular', 'waiting_for_the_sunriseRg', 'yellowtailregular',
               'sue_ellen_francisco_regular', 'EkkamaiNew_Regular', 'chulabhornlikittext_regular' , 'chulabhornlikittext_medium' , 'chulabhornlikittext_light'];
            for (let i = 1; i <= 14; i++) {
               if (i === 1) {
                  this.fillText(canvasEl1, fonts[i - 1], fullNameVal);
               } else if (i === 2) {
                  this.fillText(canvasEl2, fonts[i - 1], fullNameVal);
               } else if (i === 3) {
                  this.fillText(canvasEl3, fonts[i - 1], fullNameVal);
               } else if (i === 4) {
                  this.fillText(canvasEl4, fonts[i - 1], fullNameVal);
               } else if (i === 5) {
                  this.fillText(canvasEl5, fonts[i - 1], fullNameVal);
               } else if (i === 6) {
                  this.fillText(canvasEl6, fonts[i - 1], fullNameVal);
               } else if (i === 7) {
                  this.fillText(canvasEl7, fonts[i - 1], fullNameVal);
               } else if (i === 8) {
                  this.fillText(canvasEl8, fonts[i - 1], fullNameVal);
               } else if (i === 9) {
                  this.fillText(canvasEl9, fonts[i - 1], fullNameVal);
               } else if (i === 10) {
                  this.fillText(canvasEl10, fonts[i - 1], fullNameVal);
               } else if (i === 11) {
                  this.fillText(canvasEl11, fonts[i - 1], fullNameVal);
               } else if (i === 12) {
                  this.fillText(canvasEl12, fonts[i - 1], fullNameVal);
               } else if (i === 13) {
                  this.fillText(canvasEl13, fonts[i - 1], fullNameVal);
               } else if (i === 14) {
                  this.fillText(canvasEl14, fonts[i - 1], fullNameVal);
               }
            }
         }
      }
   }

   generateInitialize(initSignature) {
      if (initSignature !== undefined && initSignature !== 'create init signature') {
         const value = initSignature.trim();
         if (/[<|>\\\/:?*"]/g.test(value)) {
            this.translate.get('alert.create_folder_error').subscribe(s => {
               this.error = s;
            });
            this.buttonOK.disabled = true;
         } else {
            this.translate.get('alert.empty').subscribe(s => {
               this.error = s;
            });

            this.groupPatternInit = null;
            // get the context
            const canvasInit1: HTMLCanvasElement = this.canvasInitialize1.nativeElement;
            const canvasInit2: HTMLCanvasElement = this.canvasInitialize2.nativeElement;
            const canvasInit3: HTMLCanvasElement = this.canvasInitialize3.nativeElement;
            const canvasInit4: HTMLCanvasElement = this.canvasInitialize4.nativeElement;
            const canvasInit5: HTMLCanvasElement = this.canvasInitialize5.nativeElement;
            const canvasInit6: HTMLCanvasElement = this.canvasInitialize6.nativeElement;
            const canvasInit7: HTMLCanvasElement = this.canvasInitialize7.nativeElement;
            const canvasInit8: HTMLCanvasElement = this.canvasInitialize8.nativeElement;
            const canvasInit9: HTMLCanvasElement = this.canvasInitialize9.nativeElement;
            const canvasInit10: HTMLCanvasElement = this.canvasInitialize10.nativeElement;
            const canvasInit11: HTMLCanvasElement = this.canvasInitialize11.nativeElement;
            const canvasInit12: HTMLCanvasElement = this.canvasInitialize12.nativeElement;
            const canvasInit13: HTMLCanvasElement = this.canvasInitialize13.nativeElement;
            const canvasInit14: HTMLCanvasElement = this.canvasInitialize14.nativeElement;


            const fonts = ['calligraffittiregular', 'damionregular', 'dancing_scriptbold', 'great_vibesregular', 'pacificoregular',
               'pinyon_scriptregular', 'rock_saltregular', 'waiting_for_the_sunriseRg', 'yellowtailregular',
               'sue_ellen_francisco_regular', 'EkkamaiNew_Regular', 'chulabhornlikittext_regular' , 'chulabhornlikittext_medium' , 'chulabhornlikittext_light'];
            for (let i = 1; i <= 14; i++) {
               if (i === 1) {
                  this.fillText(canvasInit1, fonts[i - 1], initSignature);
               } else if (i === 2) {
                  this.fillText(canvasInit2, fonts[i - 1], initSignature);
               } else if (i === 3) {
                  this.fillText(canvasInit3, fonts[i - 1], initSignature);
               } else if (i === 4) {
                  this.fillText(canvasInit4, fonts[i - 1], initSignature);
               } else if (i === 5) {
                  this.fillText(canvasInit5, fonts[i - 1], initSignature);
               } else if (i === 6) {
                  this.fillText(canvasInit6, fonts[i - 1], initSignature);
               } else if (i === 7) {
                  this.fillText(canvasInit7, fonts[i - 1], initSignature);
               } else if (i === 8) {
                  this.fillText(canvasInit8, fonts[i - 1], initSignature);
               } else if (i === 9) {
                  this.fillText(canvasInit9, fonts[i - 1], initSignature);
               } else if (i === 10) {
                  this.fillText(canvasInit10, fonts[i - 1], initSignature);
               } else if (i === 11) {
                  this.fillText(canvasInit11, fonts[i - 1], initSignature);
               } else if (i === 12) {
                  this.fillText(canvasInit12, fonts[i - 1], initSignature);
               } else if (i === 13) {
                  this.fillText(canvasInit13, fonts[i - 1], initSignature);
               } else if (i === 14) {
                  this.fillText(canvasInit14, fonts[i - 1], initSignature);
               }
            }
         }
      }
      // }, 100);
   }

   private fillText(canvas: HTMLCanvasElement, fontName: string, text: string, marginTop?: number): void {
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      const maxWidth = canvas.width - 40;
      let size = 20;
      context.font = size + 'pt ' + fontName;
      let width = context.measureText(text).width;
      while (width > maxWidth) {
         context.font = (--size) + 'pt ' + fontName;
         width = context.measureText(text).width;
      }
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      let top = canvas.height / 2;
      if (marginTop) {
         top += marginTop;
      }
      context.fillText(text, canvas.width / 2, top);
   }

   selectPattern(event) {
      this.signatureChange = true;
      const valueSelected = event.value;
      // get the context
      const canvasEl1: HTMLCanvasElement = this.canvasPattern1.nativeElement;
      const canvasEl2: HTMLCanvasElement = this.canvasPattern2.nativeElement;
      const canvasEl3: HTMLCanvasElement = this.canvasPattern3.nativeElement;
      const canvasEl4: HTMLCanvasElement = this.canvasPattern4.nativeElement;
      const canvasEl5: HTMLCanvasElement = this.canvasPattern5.nativeElement;
      const canvasEl6: HTMLCanvasElement = this.canvasPattern6.nativeElement;
      const canvasEl7: HTMLCanvasElement = this.canvasPattern7.nativeElement;
      const canvasEl8: HTMLCanvasElement = this.canvasPattern8.nativeElement;
      const canvasEl9: HTMLCanvasElement = this.canvasPattern9.nativeElement;
      const canvasEl10: HTMLCanvasElement = this.canvasPattern10.nativeElement;
      const canvasEl11: HTMLCanvasElement = this.canvasPattern11.nativeElement;
      const canvasEl12: HTMLCanvasElement = this.canvasPattern12.nativeElement;
      const canvasEl13: HTMLCanvasElement = this.canvasPattern13.nativeElement;
      const canvasEl14: HTMLCanvasElement = this.canvasPattern14.nativeElement;

      if (valueSelected === 'pattern1') {
         this.setSelectedPattern(canvasEl1);
      } else if (valueSelected === 'pattern2') {
         this.setSelectedPattern(canvasEl2);
      } else if (valueSelected === 'pattern3') {
         this.setSelectedPattern(canvasEl3);
      } else if (valueSelected === 'pattern4') {
         this.setSelectedPattern(canvasEl4);
      } else if (valueSelected === 'pattern5') {
         this.setSelectedPattern(canvasEl5);
      } else if (valueSelected === 'pattern6') {
         this.setSelectedPattern(canvasEl6);
      } else if (valueSelected === 'pattern7') {
         this.setSelectedPattern(canvasEl7);
      } else if (valueSelected === 'pattern8') {
         this.setSelectedPattern(canvasEl8);
      } else if (valueSelected === 'pattern9') {
         this.setSelectedPattern(canvasEl9);
      } else if (valueSelected === 'pattern10') {
         this.setSelectedPattern(canvasEl10);
      } else if (valueSelected === 'pattern11') {
         this.setSelectedPattern(canvasEl11);
      } else if (valueSelected === 'pattern12') {
         this.setSelectedPattern(canvasEl12);
      } else if (valueSelected === 'pattern13') {
         this.setSelectedPattern(canvasEl13);
      } else if (valueSelected === 'pattern14') {
         this.setSelectedPattern(canvasEl14);
      }

      this.signatureChangeType = 'pattern';
      this.buttonOK.disabled = false;
   }

   selectPatternInit(event , initSignature) {
      this.initChange = true;
      const valueSelected = event.value;
      // get the context
      const canvasInit1: HTMLCanvasElement = this.canvasInitialize1.nativeElement;
      const canvasInit2: HTMLCanvasElement = this.canvasInitialize2.nativeElement;
      const canvasInit3: HTMLCanvasElement = this.canvasInitialize3.nativeElement;
      const canvasInit4: HTMLCanvasElement = this.canvasInitialize4.nativeElement;
      const canvasInit5: HTMLCanvasElement = this.canvasInitialize5.nativeElement;
      const canvasInit6: HTMLCanvasElement = this.canvasInitialize6.nativeElement;
      const canvasInit7: HTMLCanvasElement = this.canvasInitialize7.nativeElement;
      const canvasInit8: HTMLCanvasElement = this.canvasInitialize8.nativeElement;
      const canvasInit9: HTMLCanvasElement = this.canvasInitialize9.nativeElement;
      const canvasInit10: HTMLCanvasElement = this.canvasInitialize10.nativeElement;
      const canvasInit11: HTMLCanvasElement = this.canvasInitialize11.nativeElement;
      const canvasInit12: HTMLCanvasElement = this.canvasInitialize12.nativeElement;
      const canvasInit13: HTMLCanvasElement = this.canvasInitialize13.nativeElement;
      const canvasInit14: HTMLCanvasElement = this.canvasInitialize14.nativeElement;

      if (valueSelected === 'pattern1') {
         this.setSelectedPatternInit(canvasInit1);
      } else if (valueSelected === 'pattern2') {
         this.setSelectedPatternInit(canvasInit2);
      } else if (valueSelected === 'pattern3') {
         this.setSelectedPatternInit(canvasInit3);
      } else if (valueSelected === 'pattern4') {
         this.setSelectedPatternInit(canvasInit4);
      } else if (valueSelected === 'pattern5') {
         this.setSelectedPatternInit(canvasInit5);
      } else if (valueSelected === 'pattern6') {
         this.setSelectedPatternInit(canvasInit6);
      } else if (valueSelected === 'pattern7') {
         this.setSelectedPatternInit(canvasInit7);
      } else if (valueSelected === 'pattern8') {
         this.setSelectedPatternInit(canvasInit8);
      } else if (valueSelected === 'pattern9') {
         this.setSelectedPatternInit(canvasInit9);
      } else if (valueSelected === 'pattern10') {
         this.setSelectedPatternInit(canvasInit10);
      } else if (valueSelected === 'pattern11') {
         this.setSelectedPatternInit(canvasInit11);
      } else if (valueSelected === 'pattern12') {
         this.setSelectedPatternInit(canvasInit12);
      } else if (valueSelected === 'pattern13') {
         this.setSelectedPatternInit(canvasInit13);
      } else if (valueSelected === 'pattern14') {
         this.setSelectedPatternInit(canvasInit14);
      }

      this.initialChangeType = 'pattern';
      if (initSignature.length !== 0) {
         this.buttonOK.disabled = false;
      }
   }

   setSelectedPattern(canvasEI: HTMLCanvasElement) {
      const tmp = this.editPatternCanvas(canvasEI , 'pattern');
      this.imageSignaturePreview = tmp.toDataURL();
      this.imageSignatureTemp = canvasEI.toDataURL();
      this.signatureChangeObj = canvasEI;
   }

   setSelectedPatternInit(canvasInit: HTMLCanvasElement) {
      const tmp = this.editPatternCanvas(canvasInit , 'init');
      this.imageInitializePreview = tmp.toDataURL();
      this.imageInitTemp = canvasInit.toDataURL();
      this.initChangeObj = canvasInit;
   }

   editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string) {
      let canvasTmp = this.canvasPatternTmp.nativeElement;
      if (type === 'init') {
         canvasTmp = this.canvasInitializeTmp.nativeElement;
      }
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((this.includeName || this.includeDate) && type !== 'init') {
         canvasTmp.width = oldCanvas.width + 75;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, -10, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 8px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (this.includeName && this.includeDate) {
            y -= 10;
         }

         const lineSpace = 8;

         this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
   }

   editDrawCanvas(oldCanvas: HTMLCanvasElement) {
      const canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((this.includeName || this.includeDate) && this.selectPatternStyle === 'Singnature') {
         canvasTmp.width = oldCanvas.width + 300;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, 0, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 25px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 40;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (this.includeName && this.includeDate) {
            y -= 40;
         }
         const lineSpace = 25;

         this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
   }

   editImage(the_url: any) {
      if ((this.includeName || this.includeDate) && this.selectPatternStyle === 'Singnature') {
         const canvasTmp = this.canvasPatternTmp.nativeElement;
         const includeName = this.includeName;
         const includeDate = this.includeDate;
         const currentDate = this.currentDate;
         const ctx = canvasTmp.getContext('2d');
         const img = new Image();
         img.onload = () => {
            ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);
            canvasTmp.width = 280;
            canvasTmp.height = 60;
            ctx.drawImage(img, 50, 0, 100, 60);
            const datepipe: DatePipe = new DatePipe('en-US');
            const formatDate = datepipe.transform(currentDate, 'dd/MM/yyyy');
            const formatTime = datepipe.transform(currentDate,  'HH:mm:ss Z');

            ctx.font = '200 8px Arial';
            const width = ctx.measureText(formatDate + ' ' + formatTime).width + 25;

            const x = canvasTmp.width - width;
            let y = canvasTmp.height / 2;
            if ((includeName && includeDate) && this.selectPatternStyle === 'Singnature') {
               y -= 10;
            }
            const lineSpace = 8;

            this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
         };
         img.src = the_url;
         if (this.selectPatternStyle === 'Singnature') {
            document.getElementById('signatureShow').setAttribute('src', canvasTmp.toDataURL());
            this.imageSignatureTemp = the_url;
            this.imageSignaturePreview = the_url;
         }
      } else {
         if (this.selectPatternStyle === 'Singnature') {
            document.getElementById('signatureShow').setAttribute('src', the_url);
            this.imageSignatureTemp = the_url;
            this.imageSignaturePreview = the_url;
         } if (this.selectPatternStyle === 'InitializeSign') {
            document.getElementById('initializeShow').setAttribute('src', the_url);
            this.imageInitializeTemp = the_url;
            this.imageInitializePreview = the_url;
         }
      }
   }

   fillIncludeText(ctx: any, x: number, y: number, lineSpace: number, date: string, time: string) {
      const user = JSON.parse(localStorage.getItem('idex-user'));
      if (this.includeName) {
         ctx.fillText('Digital signed by', x, y);
         y = y + lineSpace;
         let limit = 19;
         if (user.name.length <= limit) {
            ctx.fillText(user.name, x, y);
            y = y + lineSpace;
         } else {
            let len = user.name.length;
            let startIndex = 0;
            let endIndex = len - 1;
            while(startIndex <= endIndex){
               let str = user.name.substring(startIndex,startIndex + limit);
               startIndex += limit;
               ctx.fillText(str, x, y);
               y = y + lineSpace;
            }
         }
      }
      if (this.includeDate) {
         ctx.fillText('Date: ' + date, x, y);
         y = y +  lineSpace;
         ctx.fillText(time, x, y);
      }
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      $('#divUpload').removeClass('drag-over');
      const data = event.dataTransfer;
      let files;
      if (data.items) {
         files = [];
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               files.push(data.items[i].getAsFile());
            }
         }
      } else {
         files = data.files;
      }
      if (files.length > 0) {
         this.loadImage(files);
      }
   }

   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   loadImage(myFile: any): void {
      if (myFile.length === 0) {
         return;
      }
      if (myFile[0] != null) {
         const ext = myFile[0].type;
         if (ext !== '') {
            if (this.validateExtension(ext) === false) {
               this.handleGetTranslate('registerSignature.errorImgFile');
               $('input[type="file"]').val('');
               $('input[type="file"]').attr('title', window.URL ? ' ' : '');
               return;
            } else {
               if (myFile[0].size <= 500000) {
                  this.renderImage(myFile[0], ext);
                  $('input[type="file"]').val('');
                  $('input[type="file"]').attr('title', window.URL ? ' ' : '');
               } else {
                  this.handleGetTranslate('registerSignature.errorFileSize');
                  $('input[type="file"]').val('');
                  $('input[type="file"]').attr('title', window.URL ? ' ' : '');
                  return;
               }
            }
         } else {
            this.handleGetTranslate('registerSignature.errorImgFile');
            $('input[type="file"]').val('');
            $('input[type="file"]').attr('title', window.URL ? ' ' : '');
         }
      }
   }

   validateExtension(v) {
      const allowedExtensions = new Array('image/gif', 'image/png', 'image/jpeg', 'image/bmp', 'image/x-ms-bmp', 'image/x-bmp');

      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   // render the image in our view
   renderImage(file, ext) {
      this.delImage();
      $('#divUpload').hide();
      // generate a new FileReader object
      const reader = new FileReader();

      // inject an image with the src url
      reader.onload = (e: any) => {
         const the_url = e.target.result;
         $('#holder').append('<div id=\'divShowImg\' style=\'padding: 5px 5px 5px 5px;text-align:center;\'>' +
            '\n\<img #imageShow src=\'' + the_url + '\' title=\'' + file.name + '\' name=\'' + file.type + '\' ' +
            'id=\'imageShow\' style=\'max-width:460px;max-height:190px;\' /></div>');


         this.editImage(the_url);
         if (this.selectPatternStyle === 'Singnature') {
            this.signatureChange = true;
            this.signatureChangeType = 'upload';
            this.imageURL = the_url;
            if(this.includeName || this.includeDate){
               setTimeout(() => {
                  this.onCheckboxIncludeChange();
               }, 50);
            }
         }
         if (this.selectPatternStyle === 'InitializeSign') {
            this.initChange = true;
            this.initialChangeType = 'upload';
            this.imageInitURL = the_url;
         }

         // this.imageSignaturePreview = the_url;
         this.buttonOK.disabled = false;
      };

      // when the file is read it triggers the onload event above.
      reader.readAsDataURL(file);
   }

   delImage() {
      const divControl = $('#divShowImg');
      divControl.remove();
      $('#divUpload').show();
   }

   private captureEvents(canvasEl: HTMLCanvasElement) {
      observableFromEvent(canvasEl, 'mousedown').pipe(
         switchMap((e) => {
            return observableFromEvent(canvasEl, 'mousemove').pipe(
               // we'll stop (and unsubscribe) once the user releases the mouse
               // this will trigger a 'mouseup' event
               takeUntil(observableFromEvent(canvasEl, 'mouseup')),
               // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
               //  .takeUntil(Observable.fromEvent(canvasEl, 'mouseleave'))
               // pairwise lets us get the previous value to draw a line from
               // the previous point to the current point
               pairwise());
         }))
         .subscribe((res: [MouseEvent, MouseEvent]) => {
            const rect = canvasEl.getBoundingClientRect();

            // previous and current position with the offset
            const prevPos = {
               x: res[0].clientX - rect.left,
               y: res[0].clientY - rect.top
            };

            const currentPos = {
               x: res[1].clientX - rect.left,
               y: res[1].clientY - rect.top
            };

            // this method we'll implement soon to do the actual drawing
            this.drawOnCanvas(prevPos, currentPos);
            // this.imageSignaturePreview = canvasEl.toDataURL();
            const tmp = this.editDrawCanvas(canvasEl);
            if (this.selectPatternStyle === 'Singnature') {
               this.imageSignaturePreview = tmp.toDataURL();
               this.imageSignatureTemp = canvasEl.toDataURL();
               this.signatureChangeType = 'draw';
               this.signatureChangeObj = canvasEl;
               this.signatureChange = true;
            }
            if (this.selectPatternStyle === 'InitializeSign') {
               this.imageInitializePreview = tmp.toDataURL();
               this.imageInitializeTemp = canvasEl.toDataURL();
               this.initialChangeType = 'draw';
               this.initChangeObj = canvasEl;
               this.initChange = true;
            }
            this.buttonOK.disabled = false;
         });
   }

   private drawOnCanvas(
      prevPos: { x: number, y: number },
      currentPos: { x: number, y: number }
   ) {
      // incase the context is not set
      if (!this.cx) {
         return;
      }

      // start our drawing path
      this.cx.beginPath();

      // we're drawing lines so we need a previous position
      if (prevPos) {
         if (this.sizeSelected === 'small') {
            this.radius = 3;
         } else if (this.sizeSelected === 'normal') {
            this.radius = 5;
         } else if (this.sizeSelected === 'large') {
            this.radius = 8;
         }

         // sets the start point
         this.cx.moveTo(prevPos.x, prevPos.y); // from
         // draws a line from the start pos until the current position
         this.cx.lineTo(currentPos.x, currentPos.y);
         // color
         this.cx.strokeStyle = this.colorSelected; // "#4bf";
         this.cx.lineWidth = this.radius;
         // strokes the current path with the styles we set earlier
         this.cx.stroke();
      }
   }

   clearCanvasSignature() {
      this.cx.clearRect(0, 0, this.width, this.height);
      if (this.selectPatternStyle === 'Singnature') {
         this.imageSignaturePreview = this.imageSignatureOriginal;
         this.signatureChange = false;
         this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=false', function (dataUrl) {
            document.getElementById('signatureTmp').setAttribute('src', dataUrl);
         });
         this.imageSignatureTemp = document.getElementById('signatureTmp').getAttribute('src');
      }
      if (this.selectPatternStyle === 'InitializeSign') {
         this.imageInitializePreview = this.imageInitOriginal;
         this.initChange = false;
         this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true', function (dataUrl) {
            document.getElementById('initializeTmp').setAttribute('src', dataUrl);
         });
         this.imageInitializeTemp = document.getElementById('initializeTmp').getAttribute('src');
      }
      if (!this.signatureChange && !this.initChange) {
         this.buttonOK.disabled = true;
      }
   }

   LoadTabs(event) {
      const indexSelected = event.index;
      this.tabSelected = indexSelected;
      if (indexSelected === 0) {
         this.clearCanvasSignature();
         this.groupPattern = null;
         if (this.selectPatternStyle === 'Singnature') {
            this.generateSignature(this.fullNameValue);
            document.getElementById('group-signature').hidden = false;
            document.getElementById('group-initial').hidden = true;
         }
         if (this.selectPatternStyle === 'InitializeSign') {
            this.generateInitialize(this.initializeName);
            document.getElementById('group-signature').hidden = true;
            document.getElementById('group-initial').hidden = false;
         }
         this.handleGetTranslate('null');
         $('input[type="file"]').val('');
         $('input[type="file"]').attr('title', window.URL ? ' ' : '');
         this.signatureChangeType = 'pattern';
      } else if (indexSelected === 1) {
         this.delImage();
         this.clearCanvasSignature();
         this.signatureChangeType = 'upload';
      } else if (indexSelected === 2) {
         if (this.selectPatternStyle === 'Singnature') {
            this.signatureChangeType = 'original';
         }
         if (this.selectPatternStyle === 'InitializeSign') {
            this.initialChangeType = 'original';
         }
         this.clearCanvasSignature();
         this.handleGetTranslate('null');
         $('input[type="file"]').val('');
         $('input[type="file"]').attr('title', window.URL ? ' ' : '');
         this.signatureChangeType = 'draw';
      }
      this.setSelectedPattern(this.canvasOriginal.nativeElement);
      if (this.selectPatternStyle === 'Singnature' && this.hasSignature) {
         this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName
            + '&isChkDate=' + this.includeDate + '&init=false', (dataUrl) => {
            document.getElementById('signatureShow').setAttribute('src', dataUrl);
            this.onCheckboxIncludeChange();
         });
      } else if(this.selectPatternStyle === 'Singnature' && !this.hasSignature && !this.noImage){
         document.getElementById('signatureShow').setAttribute('src', 'assets/images/no_signature.png');
      } else if(this.selectPatternStyle === 'Singnature' && !this.hasSignature && this.noImage){
         document.getElementById('signatureShow').setAttribute('src', 'assets/images/no_signature.png');
      }
      if (this.selectPatternStyle === 'InitializeSign' && this.hasInitial) {
         this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true', function (dataUrl) {
         document.getElementById('initializeShow').setAttribute('src', dataUrl);
      });
      } else if(this.selectPatternStyle === 'InitializeSign' && !this.hasInitial && !this.noImage) {
         document.getElementById('initializeShow').setAttribute('src', 'assets/images/no_initials.png');
      } else if(this.selectPatternStyle === 'InitializeSign' && !this.hasInitial && this.noImage) {
         document.getElementById('initializeShow').setAttribute('src', 'assets/images/no_signature.png');
      }
      if (this.selectPatternStyle === 'Singnature') {
            this.imageSignaturePreview = document.getElementById('signatureShow').getAttribute('src');
            this.imageSignatureTemp = document.getElementById('signatureTmp').getAttribute('src');
      }
      if (this.selectPatternStyle === 'InitializeSign') {
            this.imageInitializePreview = document.getElementById('initializeShow').getAttribute('src');
            this.imageInitializeTemp = document.getElementById('initializeTmp').getAttribute('src');
      }
      if (!this.signatureChange && !this.initChange) {
         this.buttonOK.disabled = true;
      }
   }

   uploadSignature(button: any) {
      if ((this.hasSignature && this.hasInitial) || (this.signatureChange && this.initChange) || (this.hasSignature && this.initChange) || (this.signatureChange && this.hasInitial)) {
         if (this.tabSelected === 0 && this.fullNameValue.trim() === '') {
            this.handleToastError('registerSignature.errorInputName');
            $('#fullname').focus();
         } else if (this.tabSelected === 0 && this.initializeName.trim() === '') {
            this.handleToastError('registerSignature.errorInputName');
            $('#initialize').focus();
         } else {
            if (this.signatureId === undefined) {
               this.signatureId = 0;
            }
            if (this.initialId === undefined) {
               this.initialId = 0;
            }
            if (this.signatureChange) {
               if (!this.imageSignatureTemp) {
                  this.imageSignatureTemp = document.getElementById('signatureTmp').getAttribute('src');
               }
               this.blobBin = atob(this.imageSignatureTemp.split(',')[1]);
               this.array = [];
               for (this.i = 0; this.i < this.blobBin.length; this.i++) {
                  this.array.push(this.blobBin.charCodeAt(this.i));
               }
               this.fileBlob = new Blob([new Uint8Array(this.array)], {type: 'image/png'});

               button.disabled = true;
               this.service.uploadSignatue(this.signatureId, "S", this.fileBlob)
                  .subscribe((response) => {
                     this.service.updateSettingSignature(this.includeName, this.includeDate)
                        .subscribe((result) => {
                           this.dialogRef.close(true);
                           this.toast.success(response);
                        });
                  }, error => {
                     button.disabled = false;
                  });
            }

            /// for Init
            if (this.initChange) {
               if (!this.imageInitializeTemp) {
                  this.imageInitializeTemp = document.getElementById('initializeTmp').getAttribute('src');
               }
               this.blobInit = atob(this.imageInitializeTemp.split(',')[1]);
               const Init = [];
               for (this.i = 0; this.i < this.blobInit.length; this.i++) {
                  Init.push(this.blobInit.charCodeAt(this.i));
               }
               this.fileInit = new Blob([new Uint8Array(Init)], {type: 'image/png'});
               button.disabled = true;
               this.service.uploadSignatue(this.initialId, "I", this.fileInit)
                  .subscribe((response) => {
                     this.dialogRef.close(true);
                     this.toast.success(response, 100);
                  }, error => {
                     button.disabled = false;
                  });

            }
         }
      } else {
         this.handleToastError('registerSignature.errorCreateSign');
         if (!this.initChange && (!this.hasSignature && !this.hasInitial)) {
            this.selectSignatureButton('InitializeSign');
         } else if (!this.signatureChange && (!this.hasSignature && !this.hasInitial)) {
            this.selectSignatureButton('Singnature');
         }
      }
   }

   handleGetTranslate(key) {
      this.translate.get(key).subscribe((msg) => {
         this.errorMessage = msg;
      });
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   closeDialog() {
      this.dialogRef.close(false);
   }

   editSignature() {
         let img = document.getElementById('signatureTmp');
         let imgTmp = new Image();
         // img2.width = 200;
         // img2.width = 50;
         this.imageSignatureTemp = img.getAttribute('src');
         imgTmp.onload = () => {
            let canvas = this.canvasOriginal.nativeElement;
            let context = canvas.getContext("2d");
            var hRatio = canvas.width / imgTmp.width;
            var vRatio = canvas.height / imgTmp.height;
            var ratio = Math.min(hRatio, vRatio);
            var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
            var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(imgTmp,0,0, imgTmp.width, imgTmp.height, centerShiftX, centerShiftY,
               (imgTmp.width) * ratio, imgTmp.height * ratio);
            const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original');

            document.getElementById('signatureShow').setAttribute('src', tmp.toDataURL());
            this.imageSignaturePreview = tmp.toDataURL();
         }
         imgTmp.src = this.imageSignatureTemp;
   }

   editCanvas(type: string): void {
      const tmp = this.editPatternCanvas(this.signatureChangeObj, type);
      this.imageSignaturePreview = tmp.toDataURL();
      document.getElementById('signatureShow').setAttribute('src', tmp.toDataURL());
      this.imageSignatureTemp = this.signatureChangeObj.toDataURL();
   }

   onCheckboxIncludeChange(e?: any) {
      this.buttonOK.disabled = false;
      this.signatureChange = true;
      if (this.selectPatternStyle === 'Singnature') {
         if (this.signatureChangeType === 'original') {
            this.editSignature();
         } else if (this.signatureChangeType === 'pattern') {
            this.editCanvas('pattern');
         } else if (this.signatureChangeType === 'upload') {
            this.editSignature();
         } else if (this.signatureChangeType === 'draw') {
            this.editCanvas('draw');
         }
      }
   }

   selectSignatureButton(id) {
         if (id === 'Singnature') {
            this.selectPatternStyle = 'Singnature';
            if (this.tabSelected === 0) {
               this.generateSignature(this.fullNameValue);
               document.getElementById('group-signature').hidden = false;
               document.getElementById('group-initial').hidden = true;
            }
            if (this.tabSelected === 1) {
               this.delImage();
            }
            if (this.tabSelected === 2 ) {
               this.clearCanvasSignature();
            }
            document.getElementById('buttonSignature').style.boxShadow = '0 0 0 2px #2ab4c0';
            document.getElementById('buttonInitializeSign').style.boxShadow = 'none';
         }
         if (id === 'InitializeSign') {
            this.selectPatternStyle = 'InitializeSign';
            if (this.tabSelected === 0) {
               this.generateInitialize(this.initializeName);
               document.getElementById('group-signature').hidden = true;
               document.getElementById('group-initial').hidden = false;
            }
            if (this.tabSelected === 1) {
               this.delImage();
            }
            if (this.tabSelected === 2 ) {
               this.clearCanvasSignature();
            }
            document.getElementById('buttonInitializeSign').style.boxShadow = '0 0 0 2px #2ab4c0';
            document.getElementById('buttonSignature').style.boxShadow = 'none';
         }
   }
}
